<!-- <div class="d-flex align-item-center justify-content-between border_10" *ngIf="t==1 || t==3">
    <div class="custom-form flex-grow-1 px-0" [ngClass]="customClass">
        <input ngx-google-places-autocomplete  type="search" [(ngModel)]="model"  [options]='options1' autocomplete="_away" (onAddressChange)="model='';handleAddressChange($event,search_canada)"
        class="input_field px-3 pt-3 w-100 notranslate" id="zip_Selection_box"  placeholder="&nbsp;"  (click)="removeZipCode()" style="cursor: pointer;" (ngModelChange)="removeZipCode()" autocomplete="off"/>
        <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
                {{label || 'postal code'}}
            </span>
        </label>
    </div>
</div> -->

<form action="" autocomplete="_away">
  <div class="d-flex align-item-center justify-content-between border_10" *ngIf="t==1 || t==3">
    <div class="custom-form flex-grow-1 px-0" [ngClass]="customClass">
      <input (keyup)="setposition()" (keydown.enter)="selectZip($event)" 
        (blur)="selectZip($event)" (keydown.tab)="selectZip($event)" type="search" [(ngModel)]="_model" 
        name="search_field1" 
        (onAddressChange)="_model='';handleAddressChange($event,search_canada)" 
        class="input_field px-3 pt-3 w-100 notranslate" placeholder="&nbsp;"
        (click)="removeZipCode();setposition()" (ngModelChange)="removeZipCode()" id="zip_code"
        autocomplete="off" (keypress)="handelInput($event)"
        (input)="findFromOurSystm($event)" />
      <label [ngClass]="[!_model  ? '' : 'label-name']" for="zip_code">
        <span class="content-name f-c-p-3">
            {{label || 'postal code'}}
        </span>
      </label>
    </div>
  </div>
</form>

<form action="" autocomplete="_away">
  <div class="d-flex align-item-center justify-content-between border_10" *ngIf="t==2">
    <div class="custom-form flex-grow-1 px-0" [ngClass]="customClass">
    <input (keyup)="setposition()" (keydown.enter)="selectZip($event)" 
        (blur)="selectZip($event)" (keydown.tab)="selectZip($event)" type="search" [(ngModel)]="_model"
        name="search_field"  
        (onAddressChange)="_model='';handleAddressChange($event,search_canada)"
        class="input_field px-3 pt-3 w-100 notranslate" placeholder="&nbsp;"
        (click)="removeZipCode();setposition()" (ngModelChange)="removeZipCode()" id="zip_code1"
        autocomplete="off" (keypress)="handelInput($event)" (input)="findFromOurSystm($event)"
        required />
    <label for="zip_code1" class="label-name" [ngClass]="{modelClass: _model && _model.length>0}">
        <span class="content-name f-c-p-3">
            {{label || 'postal code'}}
        </span>
    </label>
    </div>
  </div>
</form>